import * as yup from 'yup';
import { Schema } from 'yup';
import { getValidationErrors } from 'common/components/Forms/FormValidations';
interface ValidationParams {
    yupValidationObject: { [key: string]: Schema<any> };
    payload: any;
}
const validateWithYup = ({ yupValidationObject, payload }: ValidationParams) => {
    try {
        yup.object().shape(yupValidationObject).validateSync(payload, { abortEarly: false });
        return { valid: true };
    } catch (error: any) {
        return { valid: false, errors: getValidationErrors(error) };
    }
};

export default validateWithYup;
